import React from 'react'
import { TextInput } from 'gu-ui-kit'
import isObject from 'lodash/isObject'

const renderInputField = ({
  input,
  meta: { touched, error, submitting },
  InputProps,
  type = 'text',
  hidden,
  disabled,
  helperText,
  name,
  normalizeOnBlur,
  ...rest
}) => (
  <TextInput
    {...input}
    {...rest}
    onBlur={(e) => {
      input.onBlur(e)
      if (normalizeOnBlur) {
        input.onChange(normalizeOnBlur(e))
      }
    }}
    error={!!(touched && error)}
    type={type}
    hidden={!!hidden || type === 'hidden'}
    disabled={submitting || disabled}
    helperText={
      touched && error
        ? isObject(error)
          ? Object.values(error)
              .map((e) => rest.t(e))
              .join(', ')
          : rest.t(error)
        : helperText
    }
    InputProps={{ ...InputProps, name }}
  />
)

export default renderInputField
